import IsOnBehalfOfBar from './IsOnBehalfOfBar';

export default IsOnBehalfOfBar;
